export type ConfigurationSection = 'assignment' | 'view' | 'csv' | 'automation';
export type ManagerSidebarLinkKey = 'overview' | ConfigurationSection;

type ManagerConfigurationSidebarLink = {
  key: ManagerSidebarLinkKey;
  label: string;
  path: string;
};

const managerOverviewPath = '/CaseManagement/ManagerOverview';
const managerConfigurationPath = '/CaseManagement/ManagerConfiguration';

export const managerConfigurationSidebarLinks: ManagerConfigurationSidebarLink[] = [
  {
    key: 'overview',
    label: 'Manager Overview',
    path: managerOverviewPath,
  },
  {
    key: 'assignment',
    label: 'One-Line Routing Rules',
    path: `${managerConfigurationPath}?section=assignment`,
  },
  {
    key: 'view',
    label: 'Table & View Config',
    path: `${managerConfigurationPath}?section=view`,
  },
  {
    key: 'csv',
    label: 'CSV Export Settings',
    path: `${managerConfigurationPath}?section=csv`,
  },
  {
    key: 'automation',
    label: 'Automation Rules',
    path: `${managerConfigurationPath}?section=automation`,
  },
];

export const getManagerConfigurationSectionFromSearch = (search: string): ConfigurationSection => {
  const section = new URLSearchParams(search).get('section');

  return managerConfigurationSidebarLinks.some(
    (link) => link.key !== 'overview' && link.key === section
  )
    ? (section as ConfigurationSection)
    : 'assignment';
};
